import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { VideoSection } from "@/components/VideoSection";
import { Problem } from "@/components/Problem";
import { FortyDays } from "@/components/FortyDays";
import { WhyDesert } from "@/components/WhyDesert";
import { DayForty } from "@/components/DayForty";
import { TempioVivo } from "@/components/TempioVivo";
import { Positioning } from "@/components/Positioning";
import { Founders } from "@/components/Founders";
import { Decision } from "@/components/Decision";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { StickyCTA } from "@/components/StickyCTA";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-night font-body text-ivory antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <VideoSection />
        <Problem />
        <FortyDays />
        <WhyDesert />
        <DayForty />
        <TempioVivo />
        <Positioning />
        <Founders />
        <Decision />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}

export default App;
